module.exports = __webpack_public_path__ + "de77a722/img/chevron-down-icon.5542f65c.svg";